import React from 'react';
import { defineMessages, FormattedMessage, type MessageValue } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardConfirmationOrderNumber = (props: GiftCardConfirmationOrderNumberProps) => {
  const { orderId } = props;

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['12']} style={styles.text}>
        <FormattedMessage {...messages.orderNumberText} values={{ order_id: orderId }} />
      </BodyText>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages<{ readonly orderNumberText: { readonly order_id: MessageValue } }>({
  orderNumberText: {
    defaultMessage: 'Order #: {order_id}',
    description: 'Gift Card Confirmation Screen | Order Number Text',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    marginTop: theme.spacing['4'],
    padding: theme.spacing['4'],
  },
  text: {
    textAlign: 'center',
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardConfirmationOrderNumberProps = {
  orderId: string;
};
